module.exports = __webpack_public_path__ + "static/AutoPolicyUpdatesMobile-eeb3fda5e2fc4dc06c23ac768ebaabb1.png";